import { Box, FormControlLabel, Switch, } from "@mui/material";
import React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { Dialog } from "source/components/framework/Dialog/Dialog";
import { DialogButtons } from "source/components/framework/Dialog/DialogButtons";
import { createDateField, createUserNameField, ITaskTypeCol, modifyDateField, modifyUserNameField } from "ui/Scripts/source/models/task/taskTypeCol";

interface IFormDesignerBuilderRowOptionsDialogProps {
    lineCols: ITaskTypeCol[];
    onRemoveFieldFromLine: (id: string) => void;
    onAddFieldToLine: (id: string) => Promise<void>;
    onClose: () => void;
}

export const FormDesignerBuilderRowOptionsDialog = (props: IFormDesignerBuilderRowOptionsDialogProps) => {
    const toggleFieldInLine = (id: string, add: boolean) => {
        if (add) {
            props.onAddFieldToLine(id);
        } else {
            props.onRemoveFieldFromLine(id);
        }
    };

    const lineHasCreateUser = !!props.lineCols.find(i => i.field.equalIgnoreCase(createUserNameField));
    const lineHasCreateDate = !!props.lineCols.find(i => i.field.equalIgnoreCase(createDateField));
    const lineHasModifyUser = !!props.lineCols.find(i => i.field.equalIgnoreCase(modifyUserNameField));
    const lineHasModifyDate = !!props.lineCols.find(i => i.field.equalIgnoreCase(modifyDateField));

    return (
        <Dialog
            id="formDesignerBuilderRowOptionsDialog"
            maxWidth="xs"
            title={Translations.FormRowSettings}
            body={
                <>
                    <FormControlLabel
                        sx={{ marginLeft: 0 }}
                        control={<Switch
                            checked={lineHasCreateUser}
                            inputProps={{
                                onClick: (e) => { e.stopPropagation(); }
                            }}
                            onChange={(_e, checked) => {
                                toggleFieldInLine(createUserNameField, checked);
                            }}
                        />}
                        slotProps={{
                            typography: {
                                onClick: (e) => { e.stopPropagation(); },
                                sx: { lineHeight: "2.5" },
                            }
                        }}
                        label={Translations.FormShowCreateUser}
                    />
                    <FormControlLabel
                        sx={{ marginLeft: 0, marginRight: 0 }}
                        control={<Switch
                            checked={lineHasCreateDate}
                            inputProps={{
                                onClick: (e) => { e.stopPropagation(); }
                            }}
                            onChange={(_e, checked) => {
                                toggleFieldInLine(createDateField, checked);
                            }}
                        />}
                        slotProps={{
                            typography: {
                                onClick: (e) => { e.stopPropagation(); },
                                sx: { lineHeight: "2.5" },
                            }
                        }}
                        label={Translations.FormShowCreateDate}
                    />
                    <FormControlLabel
                        sx={{ marginLeft: 0 }}
                        control={<Switch
                            checked={lineHasModifyUser}
                            inputProps={{
                                onClick: (e) => { e.stopPropagation(); }
                            }}
                            onChange={(_e, checked) => {
                                toggleFieldInLine(modifyUserNameField, checked);
                            }}
                        />}
                        slotProps={{
                            typography: {
                                onClick: (e) => { e.stopPropagation(); },
                                sx: { lineHeight: "2.5" },
                            }
                        }}
                        label={Translations.FormShowModifyUser}
                    />
                    <FormControlLabel
                        sx={{ marginLeft: 0, marginRight: 0 }}
                        control={<Switch
                            checked={lineHasModifyDate}
                            inputProps={{
                                onClick: (e) => { e.stopPropagation(); }
                            }}
                            onChange={(_e, checked) => {
                                toggleFieldInLine(modifyDateField, checked);
                            }}
                        />}
                        slotProps={{
                            typography: {
                                onClick: (e) => { e.stopPropagation(); },
                                sx: { lineHeight: "2.5" },
                            }
                        }}
                        label={Translations.FormShowModifyDate}
                    />
                </>
            }
            actions={
                <Box display="flex" justifyContent="flex-end" width="100%">
                    <DialogButtons
                        onCancel={props.onClose}
                    />
                </Box>
            }
            onClose={props.onClose}
        />
    );
};
